module.exports = __webpack_public_path__ + "img/icn-turkey.af737a4a.svg";